import { render } from "./LoyaltyHelp.vue?vue&type=template&id=0999d9e8&scoped=true"
import script from "./LoyaltyHelp.vue?vue&type=script&lang=js"
export * from "./LoyaltyHelp.vue?vue&type=script&lang=js"

import "./LoyaltyHelp.vue?vue&type=style&index=0&id=0999d9e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999d9e8"]])

export default __exports__